module.exports = __webpack_public_path__ + "media/images/emblems/Bennwil-blason-b224e471fb7e2ad8d96862c2cada000e.png";